import React from 'react';
import { Box } from '@mui/material';
import AllocationsTab from '../components/delivery/AllocationsTab';

function toYearMonth(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

export interface AllocationsPage1Props {
  /** From layout date filter (YYYY-MM). */
  startDate: string | null;
  /** From layout date filter (YYYY-MM). */
  endDate: string | null;
}

function AllocationsPage1(props: AllocationsPage1Props) {
  const fallback = toYearMonth(new Date());
  const startDate = props.startDate ?? fallback;
  const endDate = props.endDate ?? fallback;

  return (
    <Box sx={{ p: 3 }}>
      <AllocationsTab
        startDate={startDate}
        endDate={endDate}
        useNewAllocationApis
      />
    </Box>
  );
}

export default AllocationsPage1;

